<section class="padding-60px-tb xs-padding-60px-tb bg-white"
    style="background:url('assets/image/arc-back.jpg') no-repeat" id="about-company">
    <div class="container">
        <div class="row">
            <!-- section title -->
            <div class="col-md-12 col-sm-12 col-12 text-center">
                <h2
                    class="section-title-large sm-section-title-medium xs-section-title-large text-servios font-weight-600 alt-font margin-three-bottom xs-margin-fifteen-bottom">
                    Quienes somos</h2>
                <div
                    class="text-large width-70 margin-lr-auto md-width-70 sm-width-100 margin-seven-bottom xs-margin-nineteen-bottom">
                    Somos una empresa con tres años en el mercado capacitada en el desarrollo de proyectos de Marketing
                    realizamos trabajos de herrería, carpintería, impresiones entre otros.
                </div>
            </div>
            <!-- end section title -->
        </div>
    </div>
    <div class="container ">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-8 col-sm-12 col-8 bg-servios">
                <div
                    class="display-table-cell-vertical-middle padding-ten md-padding-seven xs-padding-nineteen xs-no-padding-lr">


                    <div class="tab-style6">
                        <div class="row">
                            <div class="col-md-12 col-sm-12 col-12">
                                <!-- tab navigation -->
                                <ul class="nav nav-tabs nav-tabs-light alt-font text-large text-left margin-ten-bottom">
                                    <li class="{{active}}"><a href="#tab_sec1" data-toggle="tab">VISIÓN</a></li>
                                    <li><a href="#tab_sec2" (click)="active =''" data-toggle="tab">MISIÓN</a></li>
                                    <li><a href="#tab_sec3" data-toggle="tab">NUESTROS VALORES</a></li>
                                    <!--  <li><a href="#tab_sec4" data-toggle="tab">WHAT WE DO</a></li> -->
                                </ul>
                                <!-- tab end navigation -->
                            </div>
                        </div>
                        <div class="tab-content">
                            <!-- tab content -->
                            <div class="tab-pane med-text fade show active" id="tab_sec1">
                                <div class="row">
                                    <div class="col-md-12 col-sm-12 col-12">
                                        <div class="text-white text-large">
                                            <p>Ser reconocida en el mercado como una
                                                empresa diligente para el alcance de los
                                                ideales del cliente.</p>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <!-- end tab content -->
                            <!-- tab content -->
                            <div class="tab-pane fade in" id="tab_sec2">
                                <div class="row">
                                    <div class="col-md-12 col-sm-12 col-12">
                                        <div class="text-white text-large">
                                            <p>Brindar soluciones en los proyectos de
                                                marketing con relación tiempo, precio y
                                                calidad.</p>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <!-- end tab content -->
                            <!-- tab content -->
                            <div class="tab-pane fade in" id="tab_sec3">
                                <div class="row">
                                    <div class="col-md-12 col-sm-12 col-12">
                                        <div class="text-white text-medium">
                                            <ul class="valores">
                                                <li>
                                                    Creemos que lo principal en una
                                                    empresa radica en los principios de
                                                    lealtad, honestidad, tolerancia, respeto
                                                    a fin de que todos podamos crecer y
                                                    desarrollar está sociedad con el fin de
                                                    que ganemos todos y el beneficio sea aún
                                                    mayor para cada uno.
                                                </li>
                                            </ul>

                                        </div>
                                        <br>
                                        <div class="text-white">
                                            <ul>
                                                <li>
                                                    Una empresa capacitada para llevar a
                                                    cabo el proyecto del cliente aportando
                                                    ideas, esfuerzo, creatividad y con toda
                                                    la infraestructura para dar solvencia y
                                                    confianza a éste.
                                                </li>
                                            </ul>
                                        </div>
                                        <br>
                                        <div class="text-white">
                                            <ul>
                                                <li>
                                                    Demostrar respeto, honorabilidad y
                                                    honestidad, cumplidora con sus clientes,
                                                    funcionarios, cumpliendo y haciendo
                                                    cumplir las leyes cívicas, eticas y morales
                                                    de la sociedad en la que vivimos.
                                                </li>
                                            </ul>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <!-- end tab content -->
                            <!-- tab content -->
                            <!-- <div class="tab-pane fade in" id="tab_sec4">
                                <div class="row">
                                    <div class="col-md-12 col-sm-12 col-12">
                                        <div class="text-white">
                                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting
                                                industry. Lorem Ipsum has been the standard dummy text. Lorem Ipsum is
                                                simply dummy text of the printing and typesetting industry. Lorem Ipsum
                                                is simply dummy text of the printing and typesetting industry. Lorem
                                                Ipsum has been the standard dummy text.</p>
                                        </div>
                                        <div class="text-white">
                                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting
                                                industry. Lorem Ipsum has been the standard dummy text. Lorem Ipsum is
                                                simply dummy text of the printing and typesetting industry. Lorem Ipsum
                                                is simply dummy text of the printing and typesetting industry.</p>
                                        </div>

                                    </div>
                                </div>
                            </div> -->
                            <!-- end tab content -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>